import { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";

import { connect, useDispatch, useSelector } from "react-redux";
import {
  getDashboard,
  getOrder,
  getPopularProduct,
  getRecenetOrder,
  getRevenueChart,
  getTopSellingProduct,
  getTopSellingSeller,
  getTopUser,
  getUser,
  getUserChart,
} from "../../store/dashboard/dashboard.action";

// chart
import { Chart as ChartJS, registerables } from "chart.js";
import { Line } from "react-chartjs-2";

import { useNavigate } from "react-router-dom";
import Table2 from "../../extra/Table2";

import { IconCopy } from "@tabler/icons-react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import defaultImage from "../../../assets/images/default.jpg";
import DateRangeSelect from "../../extra/DateRangeSelect";
import formatImageUrl from "../../extra/functions";
import { getProfile } from "../../store/admin/admin.action";
import { getAllSubcategory } from "../../store/attribute/attribute.action";
import { getCategory } from "../../store/category/category.action";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import { getAdminEarning } from "../../store/redeem/redeem.action";


const Dashboard = (props) => {
  let label = [];
  let label1 = [];
  let dataUser = [];
  let data = [];
  let dataTotal = [];
  let dataWith = [];
  let dataWithOut = [];
  const {
    dashboard,
    product,
    seller,
    user,
    orderData,
    popularProduct,
    recentOrders,
    userCount,
    userChart,
    total,
    withCom,
    withOut,
  } = useSelector((state) => state.dashboard);

  const { adminTotalEarnings } = useSelector((state) => state.redeem);

  const { category } = useSelector((state) => state.category);
  const { subcategory } = useSelector((state) => state.attribute);



  useEffect(() => {
    dispatch(getAdminEarning("1", "10", "All", "All"));
    dispatch(getCategory());
    dispatch(getAllSubcategory());
  }, [])



  const [type, setType] = useState("Product");
  const [order, setOrder] = useState([]);

  const [page, setPage] = useState(1);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateRangerShowType, setDateRangerShowType] = useState({
    toggle: false,
    type: "",
  });
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [date, setDate] = useState([]);
  const [sDate, setsDate] = useState("All");
  const [eDate, seteDate] = useState("All");

  const [date2, setDate2] = useState([]);

  const [sDate3, setSDate3] = useState("All");
  const [eDate3, setEDate3] = useState("All");

  const [sDate2, setsDate2] = useState("All");
  const [eDate2, seteDate2] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : dayjs().subtract(7, "day").format("YYYY-MM-DD");
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
  };

  const startDateData = sDate === "All" ? "All" : dayjs(sDate).format("YYYY-MM-DD");
  const endDateData = eDate === "All" ? "All" : dayjs(eDate).format("YYYY-MM-DD");

  const { defaultCurrency } = useSelector((state) => state.currency);

  const [userChartData, setUserChartData] = useState();

  // chart

  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const [sDate1, setSDate1] = useState("All");
  const [eDate1, setEDate1] = useState("All");


  const startDateFormat1 = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : dayjs().subtract(7, "day").format("YYYY-MM-DD");
  };
  const endDateFormat1 = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
  };

  const startDateData1 = sDate1 === 'All' ? 'All' : dayjs(sDate1).format('YYYY-MM-DD');

  const endDateData1 = eDate1 === 'All' ? 'All' : dayjs(eDate1).format('YYYY-MM-DD');

  const [analyticTotal, setAnalyticTotal] = useState([]);
  const [analyticWith, setAnalyticWith] = useState([]);
  const [analyticWithOut, setAnalyticWithOut] = useState([]);
  const dateRangePickerRef = useRef();
  const dateRangePickerRef1 = useRef();

  useEffect(() => {
    dispatch(getProfile());
  }, [])

  useEffect(() => {
    dispatch(getDefaultCurrency())
  }, [dispatch])

  useEffect(() => {
    setAnalyticTotal(total);

  }, [total]);

  useEffect(() => {
    setAnalyticWith(withCom);
  }, [withCom]);
  useEffect(() => {
    setAnalyticWithOut(withOut);
  }, [withOut]);

  var dateAnalytic = new Date();
  var firstDay = new Date(
    dateAnalytic?.getFullYear(),
    dateAnalytic?.getMonth() - 1,
    1
  );


  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getDashboard());
    dispatch(getTopSellingProduct());
    dispatch(getTopSellingSeller());
    dispatch(getTopUser());
    dispatch(getPopularProduct());
    dispatch(getRecenetOrder());
    dispatch(getOrder(startDate, endDate));

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getUserChart(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  useEffect(() => {
    dispatch(getRevenueChart(startDateData1, endDateData1));
  }, [dispatch, startDateData1, endDateData1]);

  // Keep All/All so top-card totalUsers + todayUsers stay stable (not tied to chart range)
  useEffect(() => {
    dispatch(getUser("All", "All"));
  }, [dispatch]);

  useEffect(() => {
    setOrder(recentOrders);
    // setUserData(userCount);
    // setOrderDate(orderData);
    setUserChartData(userChart);
  }, [recentOrders, userChart]);

  const collapsedDatePicker = (type) => {
    if (type === "dateRangeOne") {
      setDateRangerShowType({
        type: "dateRangeOne",
        toggle: !dateRangerShowType.toggle,
      });
    } else {
      setDateRangerShowType({
        type: "dateRangeTwo",
        toggle: !dateRangerShowType.toggle,
      });
    }
  };

  const handleCloseDateRange = () => {
    setDateRangerShowType({
      type: "",
      toggle: false,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateRangePickerRef.current &&
        !dateRangePickerRef.current.contains(event.target) &&
        dateRangePickerRef1.current &&
        !dateRangePickerRef1.current.contains(event.target)
      ) {
        handleCloseDateRange();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Display the label name based on the startDatee
  useEffect(() => {
    if (date.length === 0) {
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),

          key: "selection",
        },
      ]);
    }
  }, [date]);

  useEffect(() => {
    if (date2.length === 0) {
      setDate2([
        {
          startDate: new Date(),
          endDate: new Date(),

          key: "selection",
        },
      ]);
    }
  }, [date2]);

  const handleOpen = (id) => {
    navigate("/admin/order/orderDetail", {
      state: id,
    });
  };

  // CHART

  if (userChartData?.length > 0) {
    userChartData.map((data_) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        data = dayjs(newDate?._id).format("DD MMM YYYY");
      } else {
        date = dayjs(newDate).format("DD MMM YYYY");
      }

      date?.length > 0 && label1.push(date);

      dataUser.push(data_.count);
    });
  }

  const sumSeries = (arr = []) =>
    arr.reduce((acc, val) => acc + (Number(val) || 0), 0);

  const getPercentChange = (arr = []) => {
    if (!arr?.length || arr.length < 2) return 0;
    const mid = Math.floor(arr.length / 2);
    const prev = sumSeries(arr.slice(0, mid));
    const curr = sumSeries(arr.slice(mid));
    if (prev === 0) return curr === 0 ? 0 : 100;
    return Math.round(((curr - prev) / Math.abs(prev)) * 100);
  };

  const formatPercentLabel = (percent) => {
    if (percent > 0) return { text: `↑ ${percent}% vs previous period`, tone: "up" };
    if (percent < 0) return { text: `↓ ${Math.abs(percent)}% vs previous period`, tone: "down" };
    return { text: `– 0% vs previous period`, tone: "flat" };
  };

  // Total: all-time from analytic API | Today: today's registrations
  const userTotalCount = Number(userCount?.totalUsers) || 0;
  const userTodayCount = Number(userCount?.todayUsers) || 0;
  const userTotalChange = formatPercentLabel(getPercentChange(dataUser));
  const userTodayChange = formatPercentLabel(0);
  const currencySymbol = defaultCurrency?.symbol || "₹";

  const createAreaGradient = (colorStops) => (context) => {
    const { chart } = context;
    const { ctx, chartArea } = chart;
    if (!chartArea) return colorStops[0]?.[1] || "rgba(185, 49, 96, 0.2)";
    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    colorStops.forEach(([stop, color]) => gradient.addColorStop(stop, color));
    return gradient;
  };

  const chartData = {
    labels: label1,

    datasets: [
      {
        type: "line",
        label: "User",
        data: dataUser,
        fill: true,
        backgroundColor: createAreaGradient([
          [0, "rgba(185, 49, 96, 0.28)"],
          [1, "rgba(185, 49, 96, 0.02)"],
        ]),
        borderColor: "#B93160",
        borderWidth: 2.5,
        tension: 0.4,
        pointBackgroundColor: "#B93160",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const userChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 8,
          padding: 18,
          color: "#6b7280",
          font: { size: 12, weight: "500" },
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#111827",
        bodyColor: "#374151",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 10,
        displayColors: false,
        callbacks: {
          title: (items) => items?.[0]?.label || "",
          label: (item) => `${item.formattedValue} Users`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#9ca3af", font: { size: 11 }, maxRotation: 0 },
        border: { display: false },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Users",
          color: "#9ca3af",
          font: { size: 11, weight: "500" },
        },
        grid: { color: "#f1f5f9", borderDash: [4, 4] },
        ticks: { color: "#9ca3af", font: { size: 11 }, precision: 0 },
        border: { display: false },
      },
    },
  };

  const handleDateApply = (dayStart, dayEnd) => {
    setsDate(dayStart);
    seteDate(dayEnd);
    dispatch(getUserChart(dayStart, dayEnd));
  };

  const handleDateClear = () => {
    setsDate("All");
    seteDate("All");
    dispatch(getUserChart("All", "All"));
  };

  // revenue chart

  if (
    analyticTotal?.length > 0 ||
    analyticWith?.length > 0 ||
    analyticWithOut?.length > 0
  ) {
    analyticTotal.map((data_) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        data = dayjs(newDate?._id).format("DD MMM YYYY");
      } else {
        date = dayjs(newDate).format("DD MMM YYYY");
      }

      date?.length > 0 && label.push(date);

      dataTotal.push(data_?.totalCommission);
    });
  }

  if (analyticWith?.length > 0 || analyticWithOut?.length > 0) {
    analyticWith.map((data_, index) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        date = newDate?._id.split("T");
      } else {
        date = newDate.split("T");
      }

      dataWith.push(data_?.totalEarningWithCommission);
    });
  }

  if (analyticWithOut?.length > 0) {
    analyticWithOut.map((data_, index) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        date = newDate?._id.split("T");
      } else {
        date = newDate.split("T");
      }

      dataWithOut.push(data_?.totalEarningWithoutCommission);
    });
  }

  const revenueTotalSum = sumSeries(dataTotal);
  const revenueWithSum = sumSeries(dataWith);
  const revenueWithOutSum = sumSeries(dataWithOut);
  const revenueTotalChange = formatPercentLabel(getPercentChange(dataTotal));
  const revenueWithChange = formatPercentLabel(getPercentChange(dataWith));
  const revenueWithOutChange = formatPercentLabel(getPercentChange(dataWithOut));

  const chartData1 = {
    labels: label,
    datasets: [
      {
        type: "line",
        label: "Total Earning",
        data: dataTotal,
        fill: false,
        backgroundColor: "#B93160",
        borderColor: "#B93160",
        borderWidth: 2.5,
        tension: 0.4,
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#B93160",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
      {
        type: "line",
        label: "Earning With Commission",
        data: dataWith,
        fill: false,
        backgroundColor: "#7C5CFC",
        borderColor: "#7C5CFC",
        borderWidth: 2.5,
        tension: 0.4,
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#7C5CFC",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
      {
        type: "line",
        label: "Earning Without Commission",
        data: dataWithOut,
        fill: false,
        backgroundColor: "#3B82F6",
        borderColor: "#3B82F6",
        borderWidth: 2.5,
        tension: 0.4,
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#3B82F6",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const revenueChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 8,
          padding: 18,
          color: "#6b7280",
          font: { size: 12, weight: "500" },
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#111827",
        bodyColor: "#374151",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 12,
        boxPadding: 6,
        usePointStyle: true,
        callbacks: {
          label: (item) =>
            ` ${item.dataset.label}: ${currencySymbol}${item.formattedValue}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#9ca3af", font: { size: 11 }, maxRotation: 0 },
        border: { display: false },
      },
      y: {
        title: {
          display: true,
          text: `Amount (${currencySymbol})`,
          color: "#9ca3af",
          font: { size: 11, weight: "500" },
        },
        grid: { color: "#f1f5f9", borderDash: [4, 4] },
        ticks: { color: "#9ca3af", font: { size: 11 } },
        border: { display: false },
      },
    },
  };



  const handleDateApply1 = (dayStart, dayEnd) => {
    setSDate1(dayStart);
    setEDate1(dayEnd);
    dispatch(getRevenueChart(dayStart, dayEnd));
  };

  const handleDateClear1 = () => {
    setSDate1("All");
    setEDate1("All");
    dispatch(getRevenueChart("All", "All"));
  };

  const copyToClipboard = (Text) => {
    navigator.clipboard.writeText(Text);
    toast.success("Order ID copied to clipboard");
  };


  // Order Table Data
  const mapData = [
    {
      Header: "No",
      width: "60px",
      Cell: ({ index }) => <span className="py-4 text-white fw-normal">{index + 1}</span>,
    },

    {
      Header: "Order Id",
      body: "orderId",
      Cell: ({ row }) => (
        <span
          className="tableBoldFont orderIdText py-4"
          style={{
            cursor: "pointer",
            color: "#0B5ED7",
          }}
          onClick={() => handleOpen(row._id)}
        >
          <b className="fw-normal text-white text-nowrap">{row?.orderId}  
            <IconCopy
            size={16}
            style={{ cursor: "pointer" }}
            className="ms-1"
            onClick={(e) => {
              e.stopPropagation();
              copyToClipboard(row?.orderId);
            }}
          /></b>
        </span>
      ),
    },

    {
      Header: "User",
      body: "user",
      Cell: ({ row }) => (
        <div>
          <span className="tableBoldFont py-4">
            <b className="fw-normal text-white">
              {row?.userId?.firstName
                ? row?.userId?.firstName + " "
                : "EraShop" + " "}
              {row?.userId?.lastName ? row?.userId?.lastName : "User"}
            </b>
          </span>
        </div>
      ),
    },
    {
      Header: "PaymentGateway",
      body: "paymentGateway",
      Cell: ({ row }) => <span className="py-4 text-white fw-normal">{row?.paymentGateway}</span>,
    },
    {
      Header: `Total (${defaultCurrency?.symbol})`,
      body: "totalPrice",
      Cell: ({ row }) => (
        <>
          <span className="py-4 text-white fw-normal">{defaultCurrency?.symbol} {row?.subTotal}</span>
        </>
      ),
    },

    // add more columns as needed
  ];

  const mapData1 = [
    {
      Header: "No",
      width: "60px",
      Cell: ({ index }) => <span className="text-white fw-normal">{index + 1}</span>,
    },
    {
      Header: "User",
      body: "firstName",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => navigate("/admin/userProfile", { state: row._id })}
          style={{ cursor: "pointer" }}
        >
          <div className="">
            <img
              src={formatImageUrl(row?.image)}
              style={{ borderRadius: "10px" }}
              height={50}
              width={50}
              alt=""
              onError={(e) => {
                e.target.error = null;
                e.target.src = defaultImage;
              }}
            />
          </div>
          <span
            className="fw-bold d-flex align-items-center text-start"
            style={{ paddingLeft: "10px" }}
          >
            <b className="fw-normal text-capitalize text-white" >
              {row.firstName + " " + row.lastName}
            </b>
          </span>
        </div>
      ),
    },

    {
      Header: "Country",
      body: "location",
      Cell: ({ row }) => {
        return (
          <>
            <div className="">
              <span className="fw-normal text-uppercase">
                <p className="mb-0 text-uppercase fw-normal text-white">{row?.location}</p>
              </span>
            </div>
          </>
        );
      },
    },
    {
      Header: "Total Order",
      body: "orderCount",
      Cell: ({ row }) => (
        <span className="mb-0 fw-normal text-white">
          {row.orderCount ? row.orderCount : 0}
        </span>
      ),
    },

    // add more columns as needed
  ];
  const mapData2 = [
    {
      Header: "No",
      width: "60px",
      Cell: ({ index }) => <span className="text-white fw-normal">{index + 1}</span>,
    },
    {
      Header: "Seller",
      body: "firstName",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => navigate("/admin/sellerProfile", { state: row._id })}
          style={{ cursor: "pointer" }}
        >
          <div className="position-relative">
            <img
              src={row?.image}
              style={{ borderRadius: "10px" }}
              height={50}
              width={50}
              alt=""
            />
          </div>
          <span
            className="d-flex align-items-center text-start text-white fw-normal"
            style={{ paddingLeft: "30px" }}
          >
            <b className=" fw-normal">{row?.firstName + " " + row?.lastName}</b>
          </span>
        </div>
      ),
    },

    {
      Header: "Total Product",
      body: "totalProduct",
      Cell: ({ row }) => (
        <span
          className="mb-0 fw-normal text-dark"
          style={{
            backgroundColor: "#c6e7ff",
            color: "#000",
            padding: "10px 15px",
            borderRadius: "5px",
          }}
        >
          {row.totalProduct ? row.totalProduct : 0}
        </span>
      ),
    },

    {
      Header: "Total Sold Product",
      body: "totalSales",
      Cell: ({ row }) => (
        <span className="mb-0 text-white fw-normal">
          {row.totalProductsSold ? row.totalProductsSold : "0"}
        </span>
      ),
    },

    // add more columns as needed
  ];
  const mapData3 = [
    {
      Header: "No",
      width: "60px",
      Cell: ({ index }) => <span className="text-white fw-normal">{parseInt(index) + 1}</span>,
    },
    {
      Header: "Product",
      body: "images",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => navigate("/admin/productDetail", { state: row })}
          style={{ cursor: "pointer" }}
        >
          <div className="">
            <img
              src={row?.mainImage}
              height={50}
              width={50}
              style={{ borderRadius: "10px" }}
              alt=""
            />
          </div>
          <span className=" boxCenter ms-3 text-white fw-normal">
            {row?.productName}
          </span>
        </div>
      ),
    },

    {
      Header: "Sold",
      Cell: ({ row }) => (
        <span className="tableBoldFont">
          <b className="fw-normal text-white">{row?.sold}</b>
        </span>
      ),
    },
    {
      Header: "Rating",
      Cell: ({ row }) => (
        <span className="tableBoldFont">
          <i className="bi bi-star-fill text-white"></i>
          <b className="fw-normal text-white">{"(" + row?.rating + ")"}</b>
        </span>
      ),
    },
  ];

  const mapData4 = [
    {
      Header: "No",
      width: "60px",
      Cell: ({ index }) => <span className="text-white fw-normal">{parseInt(index) + 1}</span>,
    },
    {
      Header: "Product",
      body: "images",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => navigate("/admin/productDetail", { state: row })}
          style={{ cursor: "pointer" }}
        >
          <div className="">
            <img
              src={row?.mainImage}
              height={50}
              width={50}
              style={{ borderRadius: "10px" }}
              alt=""
            />
          </div>
          <span className="fw-normal boxCenter" style={{ paddingLeft: "30px" }}>
            <b className="fw-normal text-white">{row?.productName}</b>
          </span>
        </div>
      ),
    },

    {
      Header: "Category",
      Cell: ({ row }) => (
        <span className="tableBoldFont">
          <p className="mb-0 fw-normal text-white">{row?.categoryName}</p>
        </span>
      ),
    },

    {
      Header: "Rating",
      Cell: ({ row }) => (
        <span className="tableBoldFont">
          <i className="bi bi-star-fill fw-normal text-white"></i>
          <b className="fw-normal text-white">{"(" + row?.rating + ")"}</b>
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="mainDashboard">
        <div className="dashboard">
          <div className="row ">
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card4 p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/user")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title4">Total Users</p>
                    <h2 className="mb-0 metric-value4">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        sDate3 === "Today" ? userCount?.todayUsers : userCount?.totalUsers
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon4">
                    <i className="bi bi-people-fill"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link4">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card4 {
      background: linear-gradient(145deg, #ffffff,rgb(231, 245, 252));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card4:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title4 {
      font-size: 14px;
      color: #6b7280; /* Gray-500 */
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value4 {
      font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6; /* Gray-900 */
    }

    .metric-icon4 {
      background: radial-gradient(circle at 30% 30%,rgb(71, 165, 228), #3b82f6);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link4 {
      font-size: 14px;
      color: #B93160; /* Blue-500 */
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link4:hover {
      color: #1d4ed8; /* Blue-700 */
    }
  `}</style>
            </div>

            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card2 p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/order")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title2">Total Orders</p>
                    <h2 className="mb-0 metric-value2">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        orderData?.totalOrders
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon2">
                    <i className="bi bi-bag-fill"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link2">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card2 {
      background: linear-gradient(145deg, #ffffff,rgb(253, 251, 236));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card2:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title2 {
      font-size: 14px;
      color: #6b7280; /* Gray-500 */
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value2 {
     font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6; /* Gray-900 */
    }

    .metric-icon2 {
      background: radial-gradient(circle at 30% 30%, #f59e0b, #fbbf24);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link2 {
      font-size: 14px;
      color: #B93160; /* Amber-500 */
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link2:hover {
      color: #f59e0b; /* Amber-700 */
    }
  `}</style>
            </div>

            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card1 p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/liveSeller")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title1">Live Sellers</p>
                    <h2 className="mb-0 metric-value1">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        dashboard?.totalLiveSeller
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon1">
                    <i className="bi bi-broadcast"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link1">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card1 {
     background: linear-gradient(145deg, #ffffff,rgb(255, 234, 230));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card1:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title1 {
      font-size: 14px;
      color: #6b7280; /* Gray-500 */
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value1 {
     font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6; /* Gray-900 */
    }

    .metric-icon1 {
      background: radial-gradient(circle at 30% 30%, #ef4444, #f87171);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link1 {
      font-size: 14px;
      color: #B93160; /* Red-500 */
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link1:hover {
      color: #b91c1c; /* Red-700 */
    }
  `}</style>
            </div>


            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card3 p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/product")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title3">Total Products</p>
                    <h2 className="mb-0 metric-value3">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        dashboard?.totalProducts
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon3">
                    <i className="bi bi-box-seam"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link3">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card3 {
      background: linear-gradient(145deg, #ffffff, #fff7ed);
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card3:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title3 {
      font-size: 14px;
      color: #6b7280; 
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value3 {
     font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6; /* Gray-900 */
    }

    .metric-icon3 {
      background: radial-gradient(circle at 30% 30%, #f97316, #fb923c);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link3 {
      font-size: 14px;
      color: #B93160; /* Orange-500 */
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link3:hover {
      color: #c2410c; /* Orange-700 */
    }
  `}</style>
            </div>
            {/* category */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card-category p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/category")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title-category">Total Categories</p>
                    <h2 className="mb-0 metric-value-category">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        category?.length
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon-category">
                    <i className="bi bi-grid-3x3-gap-fill"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link-category">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card-category {
      background: linear-gradient(145deg, #ffffff, rgb(252, 231, 243));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card-category:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title-category {
      font-size: 14px;
      color: #6b7280;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value-category {
      font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6;
    }

    .metric-icon-category {
      background: radial-gradient(circle at 30% 30%, rgb(228, 71, 165), #e91e63);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link-category {
      font-size: 14px;
      color: #B93160;
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link-category:hover {
      color: #1d4ed8;
    }
  `}</style>
            </div>
            {/* subCategory */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card-subcategory p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/category/subCategory")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title-subcategory">Total Sub Categories</p>
                    <h2 className="mb-0 metric-value-subcategory">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        subcategory?.length
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon-subcategory">
                    <i className="bi bi-list-nested"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link-subcategory">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card-subcategory {
      background: linear-gradient(145deg, #ffffff, rgb(231, 252, 239));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card-subcategory:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title-subcategory {
      font-size: 14px;
      color: #6b7280;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value-subcategory {
      font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6;
    }

    .metric-icon-subcategory {
      background: radial-gradient(circle at 30% 30%, rgb(71, 228, 131), #10b981);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link-subcategory {
      font-size: 14px;
      color: #B93160;
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link-subcategory:hover {
      color: #1d4ed8;
    }
  `}</style>
            </div>
            {/* totalAdminCommission */}
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
              style={{ cursor: "pointer" }}
            >
              <div
                className="wow-card-commission p-4 d-flex flex-column justify-content-between h-100"
                onClick={() => navigate("/admin/wallet")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 metric-title-commission">Admin Commission</p>
                    <h2 className="mb-0 metric-value-commission">
                      {loading ? (
                        <Skeleton
                          width={60}
                          baseColor={colors?.baseColor}
                          highlightColor={colors?.highlightColor}
                        />
                      ) : (
                        adminTotalEarnings
                      )}
                    </h2>
                  </div>
                  <div className="metric-icon-commission">
                    <i className="bi bi-currency-rupee"></i>
                  </div>
                </div>
                <div className="border-top mt-3">
                  <span className="metric-link-commission">View All Details</span>
                </div>
              </div>

              <style jsx>{`
    .wow-card-commission {
      background: linear-gradient(145deg, #ffffff, rgb(252, 243, 231));
      border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    .wow-card-commission:hover {
      transform: translateY(-3px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    }

    .metric-title-commission {
      font-size: 14px;
      color: #6b7280;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .metric-value-commission {
      font-size: 30px;
      font-weight: 500;
      color: #2f2b3de6;
    }

    .metric-icon-commission {
      background: radial-gradient(circle at 30% 30%, rgb(228, 165, 71), #f59e0b);
      border-radius: 30%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 26px;
    }

    .metric-link-commission {
      font-size: 14px;
      color: #B93160;
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .metric-link-commission:hover {
      color: #1d4ed8;
    }
  `}</style>
            </div>



          </div>

        

          <div className="row mb-4">
            <div className="col-xl-6 col-12 mt-4">
              <div className="dash-chart-card">
                <div className="dash-chart-card__header">
                  <div className="dash-chart-card__title-wrap">
                    <div className="dash-chart-card__icon dash-chart-card__icon--user">
                      <i className="bi bi-people-fill"></i>
                    </div>
                    <div>
                      <h6 className="dash-chart-card__title">User</h6>
                      <p className="dash-chart-card__subtitle mb-0">
                        Total registered users and today new users
                      </p>
                    </div>
                  </div>
                  <div className="dash-chart-card__date">
                    <DateRangeSelect
                      startDate={sDate}
                      endDate={eDate}
                      onApply={handleDateApply}
                      onClear={handleDateClear}
                      placeholder="Select Date"
                    />
                  </div>
                </div>

                <div className="dash-chart-kpis dash-chart-kpis--two">
                  <div className="dash-chart-kpi">
                    <div className="dash-chart-kpi__top">
                      <span className="dash-chart-kpi__label">Total Users</span>
                      <span className="dash-chart-kpi__icon dash-chart-kpi__icon--pink">
                        <i className="bi bi-people-fill"></i>
                      </span>
                    </div>
                    <h4 className="dash-chart-kpi__value">{userTotalCount || 0}</h4>
                    {/* <span className={`dash-chart-kpi__change dash-chart-kpi__change--${userTotalChange.tone}`}>
                      {userTotalChange.text}
                    </span> */}
                  </div>
                  <div className="dash-chart-kpi">
                    <div className="dash-chart-kpi__top">
                      <span className="dash-chart-kpi__label">Today</span>
                      <span className="dash-chart-kpi__icon dash-chart-kpi__icon--green">
                        <i className="bi bi-person-plus-fill"></i>
                      </span>
                    </div>
                    <h4 className="dash-chart-kpi__value">{userTodayCount || 0}</h4>
                    {/* <span className={`dash-chart-kpi__change dash-chart-kpi__change--${userTodayChange.tone}`}>
                      {userTodayChange.text}
                    </span> */}
                  </div>
                </div>

                <div className="dash-chart-card__canvas">
                  <Line data={chartData} options={userChartOptions} />
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-12 mt-4">
              <div className="dash-chart-card">
                <div className="dash-chart-card__header">
                  <div className="dash-chart-card__title-wrap">
                    <div className="dash-chart-card__icon dash-chart-card__icon--revenue">
                      <i className="bi bi-bar-chart-fill"></i>
                    </div>
                    <div>
                      <h6 className="dash-chart-card__title">Admin Revenue</h6>
                      <p className="dash-chart-card__subtitle mb-0">
                        Earnings and commissions over time
                      </p>
                    </div>
                  </div>
                  <div className="dash-chart-card__date">
                    <DateRangeSelect
                      startDate={sDate1}
                      endDate={eDate1}
                      onApply={handleDateApply1}
                      onClear={handleDateClear1}
                      placeholder="Select Date"
                    />
                  </div>
                </div>

                <div className="dash-chart-kpis">
                  <div className="dash-chart-kpi">
                    <div className="dash-chart-kpi__top">
                      <span className="dash-chart-kpi__label">Total Earning</span>
                      <span className="dash-chart-kpi__icon dash-chart-kpi__icon--pink">
                        <i className="bi bi-currency-rupee"></i>
                      </span>
                    </div>
                    <h4 className="dash-chart-kpi__value">
                      {currencySymbol}{revenueTotalSum || 0}
                    </h4>
                    {/* <span className={`dash-chart-kpi__change dash-chart-kpi__change--${revenueTotalChange.tone}`}>
                      {revenueTotalChange.text}
                    </span> */}
                  </div>
                  <div className="dash-chart-kpi">
                    <div className="dash-chart-kpi__top">
                      <span className="dash-chart-kpi__label">With Commission</span>
                      <span className="dash-chart-kpi__icon dash-chart-kpi__icon--purple">
                        <i className="bi bi-percent"></i>
                      </span>
                    </div>
                    <h4 className="dash-chart-kpi__value">
                      {currencySymbol}{revenueWithSum || 0}
                    </h4>
                    {/* <span className={`dash-chart-kpi__change dash-chart-kpi__change--${revenueWithChange.tone}`}>
                      {revenueWithChange.text}
                    </span> */}
                  </div>
                  <div className="dash-chart-kpi">
                    <div className="dash-chart-kpi__top">
                      <span className="dash-chart-kpi__label">Without Commission</span>
                      <span className="dash-chart-kpi__icon dash-chart-kpi__icon--blue">
                        <i className="bi bi-bag-fill"></i>
                      </span>
                    </div>
                    <h4 className="dash-chart-kpi__value">
                      {currencySymbol}{revenueWithOutSum || 0}
                    </h4>
                    {/* <span className={`dash-chart-kpi__change dash-chart-kpi__change--${revenueWithOutChange.tone}`}>
                      {revenueWithOutChange.text}
                    </span> */}
                  </div>
                </div>

                <div className="dash-chart-card__canvas">
                  <Line data={chartData1} options={revenueChartOptions} />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-6 col-12"  >
              <div
                className="card"
                style={{
                  borderRadius: "5px 5px 5px 5px",
                  border: "none",
                  // background: "#FFF",

                  // minHeight: "670px",

                }}
              >
                <div
                  className="heading "
                  style={{
                    borderRadius: "5px 5px 0px 0px",
                    border: "none",
                    background: "#fff",
                    marginBottom: "-2px",
                    //  maxHeight: "450px",
                  }}
                >
                  <div className="sellerMenuHeader mt-0">
                    <ul
                      className="dashboardMen d-flex justify-content-between"
                      style={{ overflowX: "scroll" }}
                    >
                      <li
                        className={`pb-0 ${type === "Product" && "activeLineDashf "
                          }`}
                      >
                        <a
                          className={`profileDash mb-0  ${type === "Product" && "activeLineDashd "
                            }`}
                          style={{ color: "#2f2b3de6", fontWeight: "400", fontSize: "18px" }}
                          onClick={() => {
                            setType("Product");
                          }}
                        >
                          Top Selling Product
                        </a>
                      </li>

                      <li
                        className={`pb-0 ${type === "Popular" && "activeLineDashf "
                          }`}
                      >
                        <a
                          className={`profileDash mb-0 ${type === "Popular" && "activeLineDashd "
                            }`}
                          style={{ color: "#2f2b3de6", fontWeight: "400", fontSize: "18px" }}
                          onClick={() => {
                            setType("Popular");
                          }}
                        >
                          Most Popular Product
                        </a>
                      </li>
                      <li
                        className={`pb-0 ${type === "Seller" && "activeLineDashf "
                          }`}
                      >
                        <a
                          className={`profileDash mb-0 ${type === "Seller" && "activeLineDashd "
                            }`}
                          style={{ color: "#2f2b3de6", fontWeight: "400", fontSize: "18px" }}
                          onClick={() => {
                            setType("Seller");
                          }}
                        >
                          Top Seller
                        </a>
                      </li>

                      <li
                        className={`pb-0 ${type === "Customer" && "activeLineDashf "
                          }`}
                      >
                        <a
                          className={`profileDash mb-0 ${type === "Customer" && "activeLineDashd "
                            }`}
                          style={{ color: "#2f2b3de6", fontWeight: "400", fontSize: "18px" }}
                          onClick={() => {
                            setType("Customer");
                          }}
                        >
                          Top Buyer
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body p-0"
                  style={{
                    backgroundColor: "#0B101D",
                    borderRadius: "9px"
                  }}
                >
                  <div className="p-0 dashBoardTable ">
                    <div className="tableMain m-0">
                      {type === "Customer" && (
                        <>
                          <Table2
                            data={user}
                            mapData={mapData1}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loading}
                            shimmer={true}
                          />
                        </>
                      )}
                      {type === "Seller" && (
                        <>
                          <Table2
                            data={seller}
                            mapData={mapData2}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loading}
                            shimmer={true}
                          />
                        </>
                      )}
                      {type === "Product" && (
                        <>
                          <Table2
                            data={product}
                            mapData={mapData3}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loading}
                            shimmer={true}
                          />
                        </>
                      )}
                      {type === "Popular" && (
                        <>
                          <Table2
                            data={popularProduct}
                            mapData={mapData4}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loading}
                            shimmer={true}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-12 mt-xl-0 mt-md-3 mt-2">
              <div
                className="card"
                style={{
                  borderRadius: "5px 5px 0px 0px",
                  border: "",

                  background: "#fff",

                  // minHeight: "670px",

                }}
              >
                <div
                  className="heading"
                  style={{
                    borderRadius: "5px 5px 0px 0px",
                    border: "none",
                    background: "#fff",

                  }}
                >
                  <div className="sellerMenuHeader  mt-2 mb-2 mx-1 p-1 " style={{}}>
                    <ul className="d-flex align-items-center">
                      <li className="d-flex align-items-center">
                        <a
                          className={` fw-medium mb-0 `}
                          style={{ color: "#2f2b3de6", fontWeight: "400", fontSize: "18px" }}
                        >
                          Recent Order
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body p-0"
                  style={{
                    backgroundColor: "#0B101D",
                    borderRadius: "9px"
                  }}
                >
                  <div className="p-0 dashBoardTable ">
                    <div className="tableMain m-0">
                      <Table2
                        data={order}
                        mapData={mapData}
                        serverPerPage={rowsPerPage}
                        serverPage={page}
                        type={"server"}
                        loading={loading}
                        shimmer={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <style jsx>{`
            .dash-chart-card {
              background: #ffffff;
              border-radius: 14px;
              border: 1px solid #eef0f4;
              box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
              padding: 18px 18px 12px;
              height: 100%;
            }

            .dash-chart-card__header {
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              gap: 12px;
              margin-bottom: 16px;
            }

            .dash-chart-card__title-wrap {
              display: flex;
              align-items: center;
              gap: 12px;
              min-width: 0;
            }

            .dash-chart-card__icon {
              width: 42px;
              height: 42px;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 18px;
              flex-shrink: 0;
            }

            .dash-chart-card__icon--user {
              background: linear-gradient(135deg, #f4729a, #b93160);
            }

            .dash-chart-card__icon--revenue {
              background: linear-gradient(135deg, #60a5fa, #2563eb);
            }

            .dash-chart-card__title {
              margin: 0;
              font-size: 18px;
              font-weight: 700;
              color: #1f2937;
              line-height: 1.2;
            }

            .dash-chart-card__subtitle {
              margin-top: 2px;
              font-size: 12px;
              color: #9ca3af;
              font-weight: 500;
            }

            .dash-chart-card__date {
              min-width: 180px;
              max-width: 240px;
              flex-shrink: 0;
            }

            .dash-chart-kpis {
              display: grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              gap: 10px;
              margin-bottom: 14px;
            }

            .dash-chart-kpis--two {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }

            .dash-chart-kpi {
              background: #f8fafc;
              border: 1px solid #eef2f7;
              border-radius: 12px;
              padding: 12px;
              min-width: 0;
            }

            .dash-chart-kpi__top {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              margin-bottom: 8px;
            }

            .dash-chart-kpi__label {
              font-size: 12px;
              color: #6b7280;
              font-weight: 500;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .dash-chart-kpi__icon {
              width: 28px;
              height: 28px;
              border-radius: 8px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
              color: #fff;
              flex-shrink: 0;
            }

            .dash-chart-kpi__icon--pink {
              background: #b93160;
            }

            .dash-chart-kpi__icon--blue {
              background: #3b82f6;
            }

            .dash-chart-kpi__icon--green {
              background: #22c55e;
            }

            .dash-chart-kpi__icon--purple {
              background: #7c5cfc;
            }

            .dash-chart-kpi__value {
              margin: 0 0 4px;
              font-size: 22px;
              font-weight: 700;
              color: #111827;
              line-height: 1.2;
            }

            .dash-chart-kpi__change {
              font-size: 11px;
              font-weight: 500;
              color: #6b7280;
            }

            .dash-chart-kpi__change--up {
              color: #16a34a;
            }

            .dash-chart-kpi__change--down {
              color: #dc2626;
            }

            .dash-chart-kpi__change--flat {
              color: #6b7280;
            }

            .dash-chart-card__canvas {
              height: 360px;
              width: 100%;
            }

            @media (max-width: 991px) {
              .dash-chart-card__header {
                flex-direction: column;
                align-items: stretch;
              }

              .dash-chart-card__date {
                max-width: 100%;
                min-width: 0;
              }

              .dash-chart-kpis {
                grid-template-columns: 1fr;
              }

              .dash-chart-card__canvas {
                height: 300px;
              }
            }
          `}</style>
        </div>
      </div>
    </>
  );
};
ChartJS.register(...registerables);

export default connect(null, {
  getDashboard,
  getTopSellingProduct,
  getTopSellingSeller,
  getTopUser,
  getUser,
  getOrder,
  getPopularProduct,
  getRecenetOrder,
  getUserChart,
  getRevenueChart,
})(Dashboard);
